import styled from "@emotion/styled";
import * as React from "react";
import { Link } from "react-router-dom";

const StyledButton = styled.button`
  border: 0;
  background: transparent;
  border-radius: 0;
  transition: 300ms ease-in-out;

  a& {
    text-decoration: none;
    color: inherit;
  }

  &:not(:disabled) {
    cursor: pointer;
  }
`;

interface BaseButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  to?: string;
}

const BaseButton = (props: BaseButtonProps) => {
  return (
    <StyledButton as={props.to ? Link : "button"} type="button" {...props} />
  );
};

export default BaseButton;
